import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CrudModeEnum } from '../../enum/crud-mode.enum';
import { b64ToBlob } from '../../../helpers/b64ToBlob.helper';
import { ContentTypeEnum } from '../../enum/content-type.enum';
import { FileSaverService } from 'ngx-filesaver';
import { FileInput } from 'ngx-material-file-input';
import { ImportInstructionModel } from '../../../models/import-instruction.model';
import { ImportInstructionService } from '../../../../pages/application/settings/import-instruction/import-instruction.service';
// Removed modal usage for instructions; we directly download DOCX now

@Component({
  selector: 'vex-form-import-base',
  templateUrl: './form-import-base.component.html',
  styleUrls: ['./form-import-base.component.scss'],
})
export class FormImportBaseComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() mode: CrudModeEnum;
  @Input() entityLabel: string;
  @Input() service: any;
  @Input() modalTitle: string;
  @Input() loading: boolean = false;
  @Input() downloadModel = true;
  @Input() customExport = false;

  @Input() canDownloadTemplateModel = false;
  @Input() customTemplate: TemplateRef<any>;

  @Input() showExtraSelect: boolean = false;
  @Input() extraSelectConfig: {
    formGroup: UntypedFormGroup;
    items: Array<any>;
    label: string;
    controlName: string;
    displayProperty?: string;
  } | null = null;

  @Input() genericId: string | null = null;
  @Input() collectionName: string | null = null;

  @Output() saveForm = new EventEmitter();
  @Output() importItems = new EventEmitter();
  @Output() customExportItems = new EventEmitter();
  @Output() fileSelected = new EventEmitter<File>();

  importInstructions: ImportInstructionModel[] = [];
  loadingInstructions = false;

  constructor(
    private fileSaver: FileSaverService,
    private importInstructionService: ImportInstructionService,
  ) {}

  ngOnInit(): void {
    this.form.get('file')?.valueChanges.subscribe(file => {
      if (file) {
        this.fileSelected.emit(file);
      }
    });

    // Charger les modes d'emploi si collectionName est fourni
    if (this.collectionName) {
      this.loadImportInstructions();
    }
  }

  loadImportInstructions(): void {
    const filters: any = {};
    if (this.collectionName) {
      filters.collectionName = this.collectionName;
    }
    if (this.genericId) {
      filters.genericId = this.genericId;
    }
    if (!filters.collectionName && !filters.genericId) return;

    this.loadingInstructions = true;
    this.importInstructionService.findAll(1, 50, 'title', 'asc', '', filters).subscribe({
      next: response => {
        this.importInstructions = response.data || [];
        this.loadingInstructions = false;
      },
      error: () => {
        this.importInstructions = [];
        this.loadingInstructions = false;
      },
    });
  }

  viewInstruction(instruction: ImportInstructionModel): void {
    // Download DOCX generated from HTML content
    this.importInstructionService.exportDocx(instruction._id);
  }

  get label() {
    return this.entityLabel.toLowerCase();
  }

  /**
   * Method for download template excel
   */
  exportTemplate() {
    if (this.customExport) {
      this.customExportItems.emit();
    } else {
      this.service.downloadExcelTemplate().subscribe((x: any) => {
        const b = b64ToBlob(x.data.b64, ContentTypeEnum.excel);
        this.fileSaver.save(b, x.data.fileName);
      });
    }
  }

  save() {
    this.saveForm.emit();
  }

  import() {
    this.importItems.emit();
  }
}
